var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "content-center",
    class: _vm.isMobile && 'wap-content-center'
  }, [_c('div', {
    staticClass: "stake-box-left"
  }, [_c('img', {
    attrs: {
      "src": require('@images/center-box-image-4.png'),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "stake-box-right"
  }, [_c('div', {
    staticClass: "stake-box-right-tile-line"
  }, [_c('div', {
    staticClass: "stake-box-title"
  }, [_vm._v(" " + _vm._s(_vm.$lang('Consignment')) + " ")]), _c('div', {
    staticClass: "stake-box-sub"
  }, [_vm._v(" " + _vm._s(_vm.$lang('available')) + ": " + _vm._s(_vm.nftAvailableNum) + " ")])]), _c('div', {
    staticClass: "hor-line"
  }), _c('div', {
    staticClass: "stake-input-line m-t-20"
  }, [_c('InputNumCalView', {
    attrs: {
      "input-min": 1,
      "input-max": _vm.nftAvailableNum
    },
    on: {
      "updateInputValue": _vm.updateInputNumber
    }
  }), _c('div', {
    staticClass: "stake-button",
    on: {
      "click": _vm.confirmConsignment
    }
  }, [_vm._v(_vm._s(_vm.$lang('Confirm')))])], 1), _c('div', {
    staticClass: "stake-box-sub-2 m-t-20"
  }, [_vm._v(_vm._s(_vm.$lang('On consignment')) + ": " + _vm._s(_vm.nftLockedNum))]), _c('div', {
    staticClass: "stake-input-line"
  }, [_c('InputNumCalView', {
    attrs: {
      "input-min": 1,
      "input-max": _vm.nftLockedNum
    },
    on: {
      "updateInputValue": _vm.updateRemoveNumber
    }
  }), _c('div', {
    staticClass: "stake-button stake-button-remove",
    on: {
      "click": _vm.confirmRemove
    }
  }, [_vm._v(_vm._s(_vm.$lang('Removed')))])], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };